import React from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Layout() {
  return (
    <div className="fp-shell">
      <Header />
      <main className="fp-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
